import {
    any,
    array,
    nativeEnum,
    number,
    object,
    preprocess,
    string,
    TypeOf,
} from 'zod';

import { Classification, ModelImage } from './common';
import { Images } from './image';
import { ProductLabel, ProductPerson } from './product';

/* ----------------------------- CollectionType ----------------------------- */

export enum CollectionType {
    Dynamic = 'dynamic',
    Generic = 'generic',
    Season = 'season',
    Show = 'show',
    Personalized = 'personalized',
}

/* ----------------------------- CollectionChild ---------------------------- */

export const CollectionChild = object({
    classification: nativeEnum(Classification),
    id: string(),
});
export type CollectionChild = TypeOf<typeof CollectionChild>;

/* ---------------------------- CollectionExtend ---------------------------- */

export const CollectionExtend = object({
    label: ProductLabel.optional(),
});
export type CollectionExtend = TypeOf<typeof CollectionExtend>;

/* ------------------------------- Collection ------------------------------- */

export const Collection = object({
    categories: array(string()),
    children: array(CollectionChild).default([]),
    description: string().default(''),
    id: string(),
    image: ModelImage.optional(),
    images: Images,
    name: string(),
    reference: string(),
    seasonNumber: string()
        .or(number())
        .transform((seasonNumber) =>
            typeof seasonNumber === 'string'
                ? seasonNumber
                : String(seasonNumber),
        )
        .optional(),
    shortDescription: string().default(''),
    type: nativeEnum(CollectionType),
    visibleFrom: string(),
    visibleTo: string().optional(),
    persons: array(ProductPerson),
    showId: string().optional(),
    extend: CollectionExtend.optional(),

    /* START Not Currently in the API */
    published: string().optional(),
    secondaryTitle: string().optional(),
    /* END */
});
export type Collection = TypeOf<typeof Collection>;

/* ------------------------- GetCollectionsResponse ------------------------- */

export const AllCollectionsResponse = object({
    data: preprocess((data: unknown) => {
        const result = array(any()).parse(data);
        return result.filter((x: unknown): x is Collection => {
            const res = Collection.safeParse(x);

            if (!res.success) console.log(res.error);

            return res.success;
        });
    }, array(Collection)),
});
export type AllCollectionsResponse = TypeOf<typeof AllCollectionsResponse>;
